/** @typedef {import('../CostEstimateData').CostEstimateData} CostEstimateData */

import { _t } from 'lang';
import { useCallback } from 'react';
import { useData } from 'pages/finance/cost-estimate/add-cost-estimate/providers/DataProvider';
import FormRow from 'components/forms/FormRow';
import { useClient } from 'providers/client/ClientProvider';
import WysiwygEditor from 'components/inputs/wysiwyg/WysiwygEditor';

/**
 * The description of a cost estimate.
 */
export default function CostEstimateDescription() {
  const { clientId } = useClient();
  const { data, updateData } = useData();

  // This is already debounced in the WysiwygEditor.
  const onChange = useCallback((description) => updateData({ description }), [updateData]);

  return (
    <FormRow
      label={_t('Scope description')}
      input={
        <WysiwygEditor
          clientId={clientId}
          permissionSlug="FINANCE_MANAGE_FINANCE"
          initialContent={data.description}
          onChange={onChange}
        />
      }
    />
  );
}
